import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { DetailTemplateComponent } from "./detail-template.component";

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    DetailTemplateComponent,
  ],
  exports: [
    DetailTemplateComponent,
  ],
})

export class DetailTemplateModule {

}
